/** @format */

import mutations from "./mutations";
import getters from "./getters";
import actions from "./actions";

export default {
  namespaced: true,
  state() {
    return {
      practices: {},
      medicalLetterRequests: [],
      medicalLetterRequest: {},
      medicalLetterRequestQuestions: {},
      alternativeDoctor: [],
      signature: {},
      doctorsProfile: [],
      doctorProfile: {},
      doctor: {},
      emailError: "",
    };
  },
  mutations: mutations,
  actions: actions,
  getters: getters,
};
